import LayoutItem from './LayoutItem';

import './LayoutItem.scss';

export default LayoutItem;
